// Pure helpers for sidebar nav-group active-state resolution.
//
// The naive "any child of group matches pathname or pathname.startsWith(to + '/')"
// strategy lights up multiple groups when one group's child path is a prefix of
// another group's child path (e.g. People hosts /admin/freelancer-timesheets but
// Admin hosts the bare /admin Settings link — both groups would highlight on
// People routes). Resolve by picking the group whose child has the longest
// matching prefix; ties keep both active (uniqueness of `to` makes this rare).

export function pathMatchLength(pathname, to) {
  if (!to || typeof pathname !== 'string') return 0
  if (pathname === to) return to.length
  if (pathname.startsWith(to + '/')) return to.length
  return 0
}

export function groupBestMatchLength(pathname, group) {
  if (!group || !Array.isArray(group.children) || group.children.length === 0) return 0
  let best = 0
  for (const child of group.children) {
    const len = pathMatchLength(pathname, child.to)
    if (len > best) best = len
  }
  return best
}

export function makeGroupIsActive(pathname, allGroups) {
  const groups = (allGroups || []).filter(Boolean)
  let globalBest = 0
  for (const g of groups) {
    const len = groupBestMatchLength(pathname, g)
    if (len > globalBest) globalBest = len
  }
  return (group) => {
    if (!group || globalBest === 0) return false
    return groupBestMatchLength(pathname, group) === globalBest
  }
}
